export default import.meta.ROLLUP_FILE_URL_fh8A8xhmk_8WwfieG$mE8A;